import { render, staticRenderFns } from "./GenderAgeBreakdown.vue?vue&type=template&id=a9e257a4&scoped=true"
import script from "./GenderAgeBreakdown.vue?vue&type=script&lang=js"
export * from "./GenderAgeBreakdown.vue?vue&type=script&lang=js"
import style0 from "./GenderAgeBreakdown.vue?vue&type=style&index=0&id=a9e257a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e257a4",
  null
  
)

export default component.exports